import styles from './Deals.module.css';

import classNames from 'classnames';
import React, { useState } from 'react';

import { useDocumentTitle } from 'src/hooks/useDocumentTitle';

import { Stack } from 'src/components/themed/Stack';
import { Tabs, tabId, tabPanelId } from 'src/components/Tabs';
import { Typography } from 'src/components/themed/Typography';

import { Purchases } from './Purchases';
import { MyRentals } from '../Rentals/MyRentals';

const PURCHASES = 'Purchases';
const RENTAL = 'Rental Deals';

/**
 * The buyer's own deals, split by vertical: Purchases (delivery escrow + Buy Now direct
 * transfers) and Rental. Browse lives on the Listings/Rentals tabs; this tab is "my
 * transactions". Reachable only with the account session — route-gated in `client-app.tsx`
 * (app#238, api#402) — so the rental section is safe to render authed.
 *
 * The legacy sale escrow had a tab of its own until onchain-tron#65; its Buy Now half moved into
 * Purchases rather than going away with it.
 */
export const Deals = () => {
  const [activeTab, setActiveTab] = useState(PURCHASES);
  useDocumentTitle(activeTab);

  return (
    <div className={classNames('container', styles.container)}>
      <Stack width="100%" gap={4} p={4} pb={30} maxWidth="750px">
        <Stack width="100%" pl={4}>
          <Typography as="h1" id="deals-heading" fontWeight="600" variant="title3" color="white">
            Your Deals
          </Typography>
        </Stack>
        <Tabs
          id="deals"
          tabs={[PURCHASES, RENTAL]}
          activeTab={activeTab}
          onChangeTab={setActiveTab}
          aria-labelledby="deals-heading"
        />
        <div role="tabpanel" id={tabPanelId('deals')} aria-labelledby={tabId('deals', activeTab)}>
          {activeTab === PURCHASES ? <Purchases /> : <MyRentals />}
        </div>
      </Stack>
    </div>
  );
};
